import { useMemo } from 'react';

import { COMPANY_KEY_PARAM, WAREHOUSE_KEY_PARAM } from '@/common/constants';
import useQueryParams from '@/common/hooks/useQueryParams';
import useWarehouses from '@/common/hooks/warehouses/useWarehouses';
import SessionStorageScanbat from '@/common/services/SessionStorage.scanbat';

const useLoginContainer = () => {
  const getQueryParams = useQueryParams();

  const scanbatService = SessionStorageScanbat.getService();

  const {
    data: warehouse,
    isLoading: isLoadingWarehouse,
    isFetching: isFetchingWarehouse,
  } = useWarehouses({
    company: getQueryParams.get(COMPANY_KEY_PARAM),
    code: getQueryParams.get(WAREHOUSE_KEY_PARAM),
  });

  const getWarehouse = useMemo(() => {
    if (warehouse) {
      scanbatService.setScanbatCompany(getQueryParams.get(COMPANY_KEY_PARAM));
      scanbatService.setScanbatWarehouse(
        getQueryParams.get(WAREHOUSE_KEY_PARAM),
      );

      return warehouse;
    }

    return null;
  }, [getQueryParams, scanbatService, warehouse]);

  const isDisabled = useMemo(() => {
    const loading = isLoadingWarehouse || isFetchingWarehouse;

    return {
      disabled: loading || !getWarehouse?.code,
      loading,
    };
  }, [getWarehouse, isFetchingWarehouse, isLoadingWarehouse]);

  return {
    company: getQueryParams.get(COMPANY_KEY_PARAM),
    isDisabled,
    warehouse: getWarehouse,
  };
};

export default useLoginContainer;
